import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftStorageServer } from "namirasoft-storage";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { StorageLayout } from "./StorageLayout";
import { StorageRoutes } from "./StorageRoutes";
import AssignmentEditPage from "./pages/AssignmentEditPage";
import AssignmentListPage from "./pages/AssignmentListPage";
import AssignmentViewPage from "./pages/AssignmentViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import StorageEditPage from "./pages/StorageEditPage";
import StorageListPage from "./pages/StorageListPage";
import StorageUserEditPage from "./pages/StorageUserEditPage";
import StorageUserListPage from "./pages/StorageUserListPage";
import StorageUserViewPage from "./pages/StorageUserViewPage";
import StorageViewPage from "./pages/StorageViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        product_id={ProductUUID.NAMIRASOFT_STORAGE}
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        navigate={navigate}
        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_STORAGE = new EnvService("REACT_APP_BASE_URL_STORAGE", true).getString();

            let storage = new NamirasoftStorageServer(REACT_APP_BASE_URL_STORAGE, result.account.token_manager, result.notifier.onError);

            let servers = { storage };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (
                        <Routes>
                            <Route path={StorageRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={StorageRoutes.StorageList} element={<StorageListPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.StorageNew} element={<StorageEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.StorageCopy(":id")} element={<StorageEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.StorageView(":id")} element={<StorageViewPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.StorageEdit(":id")} element={<StorageEditPage {...result} servers={servers} isEdit={true} />} />

                            <Route path={StorageRoutes.StorageUserList} element={<StorageUserListPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.StorageUserNew} element={<StorageUserEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.StorageUserCopy(":id")} element={<StorageUserEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.StorageUserView(":id")} element={<StorageUserViewPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.StorageUserEdit(":id")} element={<StorageUserEditPage {...result} servers={servers} isEdit={true} />} />

                            <Route path={StorageRoutes.AssignmentList} element={<AssignmentListPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.AssignmentNew} element={<AssignmentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.AssignmentCopy(":id")} element={<AssignmentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={StorageRoutes.AssignmentView(":id")} element={<AssignmentViewPage {...result} servers={servers} />} />
                            <Route path={StorageRoutes.AssignmentEdit(":id")} element={<AssignmentEditPage {...result} servers={servers} isEdit={true} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes>
                    ))}
                />
            );
        }}
        renderOnLogout={(result: NSARouterMakerResult, banned: boolean) =>
        {
            if (banned)
                return (
                    <Routes>
                        <Route path="*" element={<LoginPage {...result} />} />
                    </Routes>
                );
            return (
                <Routes>
                    <Route path={StorageRoutes.Home} element={<LoginPage {...result} />} />
                    <Route path="*" element={<LoginPage {...result} />} />
                </Routes>
            );
        }}
        getNSALayout={(props) =>
        {
            return (
                <StorageLayout {...props}>
                    {props.children}
                </StorageLayout>
            );
        }}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />;
}

export default Router;